//include 10
jQuery(function(){

    window.ppComponents = window.ppComponents || {};
    window.ppComponents.select2 = window.ppComponents.select2 || {};
    window.ppComponents.select2.initialize = function (elements) {
        elements.each(function () {
            var placeholdertext = $(this).attr('placeholder') || $(this).data('placeholder');
            var cssClass = $(this).data('dropdown-css-class') || "";
            var containerCssClass = $(this).data("container-css-class") || "";
            var allowClear = $(this).data('allow-clear') || false;
            var closeOnSelect = ($(this).data('close-select') == 'disabled') ? false : true;

            if (!placeholdertext) {
                var emptyOption = $(this).find("option[value='']");
                if (emptyOption.length > 0) {
                    placeholdertext = emptyOption.text();
                } else { 
                    placeholdertext = " ";
                }
            }

            var placeholder = {
                id: "",
                text: placeholdertext
            };

            $(this).select2({
                placeholder: placeholder,
                closeOnSelect: closeOnSelect,
                minimumResultsForSearch: Infinity, // preventing the searchbox
                dropdownCssClass: cssClass,
                containerCssClass: containerCssClass
            });

            var $this = $(this);

            if(!!cssClass){
                $(this).off("select2:open").on("select2:open",function(){
                    $this.data('select2').$dropdown.addClass(cssClass);
                    $this.data('select2').$dropdown.addClass(containerCssClass);
                });
                $(this).off("select2:closing").on("select2:closing",function(){
                    $this.data('select2').$dropdown.removeClass(cssClass);
                    $this.data('select2').$dropdown.removeClass(containerCssClass); // was a misunderstanding but I do not want to remove it yet
                });
            }

            // not used?
            /*var enableResizableText = $this.is("[data-resizable-text]");
            $this.off("select2:select").on("select2:select", function (e) {
                if (enableResizableText) {
                    var selectionWrapper = $this.parent().find(".selection");
                    var rendered = selectionWrapper.find(".select2-selection__rendered");
                    rendered.css("font-size", "");
                    var parentWidth = selectionWrapper.width(),
                        parentHeight = selectionWrapper.height(),
                        width = rendered.width(),
                        height = rendered.height();
                    var computedStyle = window.getComputedStyle($this[0]);
                    var fontsize = computedStyle.getPropertyValue('font-size');
                    fontsize = parseFloat(fontsize);
                    while (width > (parentWidth - 25) || height > parentHeight) {
                        fontsize *= 0.95;
                        rendered.css("font-size", fontsize + "px");
                        width = rendered.width();
                        height = rendered.height();
                    }
                }
            });*/

        });
    };

    window.ppComponents.select2.initialize($('.select2'));

    if (!window.pixelpoint.isMobile.any()) {
        $('body').on("select2:open", ".month-select.hoversupport", function (e) {
            $(this).parents('.menu-level-1,.supersection').removeClass('hover').addClass('hover');
        });
        $('body').on("select2:close", ".month-select.hoversupport", function (e) {
            var that = $(this);
            setTimeout(function (e) {
                $(that).parents('.menu-level-1,.supersection').removeClass('hover');
            }, 100);
        });
    }

    $(window).on("orientationchange", function () {
        $(".month-select.select2-hidden-accessible").each(function () {
            var self = $(this);
            self.select2("destroy");
            setTimeout(function () {
                window.ppComponents.select2months.initialize(self);
            }, 50);
        });
    });
});